import { keyEmptyCheck } from 'aurora-utils/utils';

export const BUYER_TYPES = {
  UAE_RESIDENT: 'UAE RESIDENT',
  NON_UAE_RESIDENT: 'NON UAE RESIDENT',
  COMPANY: 'COMPANY',
  GOVERNMENT: 'GOVERNMENT',
};

export const BUYER_TYPES_OPTIONS = [
  {
    label: keyEmptyCheck('uae_resident_party'),
    value: BUYER_TYPES.UAE_RESIDENT,
  },
  {
    label: keyEmptyCheck('company'),
    value: BUYER_TYPES.COMPANY,
  },
  {
    label: keyEmptyCheck('government'),
    value: BUYER_TYPES.GOVERNMENT,
  },
];

export const BUYER_TYPE_KEY = 'buyerType';

export const FILTERS_KEYS = {
  [BUYER_TYPES.UAE_RESIDENT]: {
    eid: 'eid',
    dateOfBirth: 'dateOfBirth',
  },
  [BUYER_TYPES.NON_UAE_RESIDENT]: {
    nationality: 'nationality',
    passportNumber: 'passportNumber',
    email: 'email',
    mobileNumber: 'mobileNumber',
  },
  [BUYER_TYPES.COMPANY]: {
    tradeLicense: 'tradeLicense',
  },
  [BUYER_TYPES.GOVERNMENT]: {
    licenseNumber: 'licenseNumber',
    nameEn: 'nameEn',
    nameAr: 'nameAr',
  },
};

export const BUYER_DOCUMENTS_ATTRIBUTES = {
  [BUYER_TYPES.UAE_RESIDENT]: [
    {
      active: true,
      attributeType: 'file',
      attributeSubType: 'file',
      name: 'EID',
      description: null,
      title: 'eid_card',
      isMultiple: true,
      acceptFileTypes: 'application/pdf',
    },
  ],
  [BUYER_TYPES.COMPANY]: [
    {
      active: true,
      attributeType: 'file',
      attributeSubType: 'file',
      name: 'TRADE_LICENSE',
      description: null,
      title: 'trade_license_document',
      isMultiple: true,
      acceptFileTypes: 'application/pdf',
    },
  ],
};

export const BUYER_REPRESENTATIVE_DOCS_ATTRIBUTES = [
  {
    active: true,
    attributeType: 'file',
    attributeSubType: 'file',
    name: 'POA_DOC',
    description: null,
    title: 'POWER_OF_ATTORNEY',
    isMultiple: true,
    mandatory: true,
    acceptFileTypes: 'application/pdf',
  },
];
